import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import PersonalCare from './components/PersonalCare';
import CompanionCare from './components/CompanionCare';
import DementiaCare from './components/DementiaCare';
import SpecialtyCare from './components/SpecialtyCare';
import TherapeuticCare from './components/TherapeuticCare';
import SkilledNursing from './components/SkilledNursing';
import PostSurgeryRecovery from './components/PostSurgeryRecovery';
import VirtualTherapist from './components/VirtualTherapist';
import ScrollToTop from './components/ScrollToTop';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/personal-care" element={<PersonalCare />} />
        <Route path="/companion-care" element={<CompanionCare />} />
        <Route path="/dementia-care" element={<DementiaCare />} />
        <Route path="/specialty-care" element={<SpecialtyCare />} />
        <Route path="/therapeutic-care" element={<TherapeuticCare />} />
        <Route path="/skilled-nursing" element={<SkilledNursing />} />
        <Route path="/post-surgery-recovery" element={<PostSurgeryRecovery />} />
        <Route path="/virtual-therapist" element={<VirtualTherapist />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
